// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e2b75d02","520":"72bfef1b"}[chunkId] + ".chunk.js";
};